// @ts-nocheck

export enum DocumentType {
    Local = "Local",
    Remote = "Remote"
}

export enum UrlSourceEnum {
    TCEWI = "TCEWI",
    Other = "Other"
}

export enum DocumentType2 {
    Local = "Local",
    Remote = "Remote"
}

export enum UrlSourceEnum2 {
    TCEWI = "TCEWI",
    Other = "Other"
}

export enum PrimitiveTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan"
}

export enum ApplicationLogLevelType {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum AutomationDataTypeEnum {
    Bool = "Bool",
    Int = "Int",
    DInt = "DInt",
    LInt = "LInt",
    LReal = "LReal",
    Datetime = "Datetime",
    String = "String",
    Byte = "Byte",
    SInt = "SInt",
    Real = "Real",
    UInt = "UInt",
    UDInt = "UDInt",
    ULInt = "ULInt"
}

export enum SegregationTagStatus {
    Available = "Available",
    Locked = "Locked"
}

export enum TimerModeEnum {
    OneShot = "OneShot",
    Periodic = "Periodic"
}

export enum TimerTypeEnum {
    Delay = "Delay",
    SpecificTime = "SpecificTime"
}

export interface LogMessageCatalog {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Owner` |
     * | Type | `Edm.String` |
     */
    Owner: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MessageId` |
     * | Type | `Edm.Int32` |
     */
    MessageId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.ApplicationLogLevelType` |
     */
    Level: ApplicationLogLevelType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogParameters` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogParameters)` |
     */
    LogMessageCatalogParameters?: Array<LogMessageCatalogParameters>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogLanguages` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogLanguages)` |
     */
    LogMessageCatalogLanguages?: Array<LogMessageCatalogLanguages>;
}

export type LogMessageCatalogId = string | {Id: string};

export interface LogMessageCatalogParameters {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterKey` |
     * | Type | `Edm.String` |
     */
    ParameterKey: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Edm.String` |
     */
    ParameterType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogParametersId = string | {Id: string};

export interface LogMessageCatalogLanguages {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogLanguagesId = string | {Id: string};

export interface File {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PayloadSize` |
     * | Type | `Edm.Int64` |
     */
    PayloadSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedBy` |
     * | Type | `Edm.String` |
     */
    CreatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedBy` |
     * | Type | `Edm.String` |
     */
    LastUpdatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder_Id` |
     * | Type | `Edm.Guid` |
     */
    Folder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    Folder?: Folder | null;
}

export type FileId = string | {Id: string};

export interface Folder {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentFolder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    ParentFolder?: Folder | null;
}

export type FolderId = string | {Id: string};

export interface SegregationTag {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagStatus` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.SegregationTagStatus` |
     */
    TagStatus: SegregationTagStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLogRelevant` |
     * | Type | `Edm.Boolean` |
     */
    IsLogRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
}

export type SegregationTagId = string | {Id: string};

export interface Category {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.CategoryFacet)` |
     */
    Facets?: Array<CategoryFacet>;
}

export type CategoryId = string | {Id: string};

export interface DocumentCategory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.DocumentCategoryFacet)` |
     */
    Facets?: Array<DocumentCategoryFacet>;
}

export type DocumentCategoryId = string | {Id: string};

export interface DocumentEntityLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNId` |
     * | Type | `Edm.String` |
     */
    DocumentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentRevision` |
     * | Type | `Edm.String` |
     */
    DocumentRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityType` |
     * | Type | `Edm.String` |
     */
    LinkedEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     */
    LinkedEntityId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.DocumentEntityLinkFacet)` |
     */
    Facets?: Array<DocumentEntityLinkFacet>;
}

export type DocumentEntityLinkId = string | {Id: string};

export interface Document {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Url` |
     * | Type | `Edm.String` |
     */
    Url: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UrlSource` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.ReadingModel.UrlSourceEnum` |
     */
    UrlSource: UrlSourceEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    Icon_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFile_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    LocalFile_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.ReadingModel.DocumentType` |
     */
    RepositoryType: DocumentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Collection(Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.Category)` |
     */
    Category?: Array<Category>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    Icon_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFile_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    LocalFile_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.DocumentFacet)` |
     */
    Facets?: Array<DocumentFacet>;
}

export type DocumentId = string | {Id: string};

export interface CategoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category_Id` |
     * | Type | `Edm.Guid` |
     */
    Category_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.Category` |
     */
    Category?: Category | null;
}

export type CategoryFacetId = string | {Id: string};

export interface DocumentCategoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategory_Id` |
     * | Type | `Edm.Guid` |
     */
    DocumentCategory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategory` |
     * | Type | `Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.DocumentCategory` |
     */
    DocumentCategory?: DocumentCategory | null;
}

export type DocumentCategoryFacetId = string | {Id: string};

export interface DocumentEntityLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentEntityLink_Id` |
     * | Type | `Edm.Guid` |
     */
    DocumentEntityLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentEntityLink` |
     * | Type | `Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.DocumentEntityLink` |
     */
    DocumentEntityLink?: DocumentEntityLink | null;
}

export type DocumentEntityLinkFacetId = string | {Id: string};

export interface DocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.OpcenterEX.FN.Document.Document.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
}

export type DocumentFacetId = string | {Id: string};

export interface ExecutionError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCode` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ErrorCode: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
}

export interface PrecheckExecution {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullName` |
     * | Type | `Edm.String` |
     */
    FullName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
}

export interface SitUafExecutionDetail {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrecheckDetails` |
     * | Type | `Collection(Siemens.SimaticIT.Unified.Common.PrecheckExecution)` |
     * | Nullable | `false` |
     */
    PrecheckDetails: Array<PrecheckExecution>;
}

export interface CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Succeeded` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Succeeded: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SitUafExecutionDetail` |
     * | Type | `Siemens.SimaticIT.Unified.Common.SitUafExecutionDetail` |
     */
    SitUafExecutionDetail: SitUafExecutionDetail | null;
}

export interface FunctionResponse extends CommandResponse {
}

export interface PreCheckResponse extends CommandResponse {
}

export interface ServiceLayerUnityError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `commandcallstack` |
     * | Type | `Collection(Edm.String)` |
     */
    commandcallstack: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `stacktrace` |
     * | Type | `Edm.String` |
     */
    stacktrace: string | null;
}

export interface ServiceLayerErrorObject {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `code` |
     * | Type | `Edm.String` |
     */
    code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `message` |
     * | Type | `Edm.String` |
     */
    message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `innererror` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerUnityError` |
     */
    innererror: ServiceLayerUnityError | null;
}

export interface ServiceLayerError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `error` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerErrorObject` |
     */
    error: ServiceLayerErrorObject | null;
}

export interface LinkCategoriesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    CategoryIds: Array<string>;
}

export interface LinkCategories {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    DocumentCategoryNIds: Array<string>;
}

export interface DeleteDocumentCategoryResponse extends CommandResponse {
}

export interface DeleteDocumentCategory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkDocumentResponse extends CommandResponse {
}

export interface UnlinkDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CopyDocumentRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
}

export interface CopyDocumentRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetRevision: string;
}

export interface CreateDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
}

export interface CreateDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.DocumentType` |
     * | Nullable | `false` |
     */
    RepositoryType: DocumentType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    Icon: FileType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFile` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    LocalFile: FileType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    CategoryNIds: Array<string>;
}

export interface UploadDocumentsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UploadedFileIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UploadedFileIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotUploadedFileIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotUploadedFileIds: Array<string>;
}

export interface UploadDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FileIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProjectName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProjectName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FolderName` |
     * | Type | `Edm.String` |
     */
    FolderName: string | null;
}

export interface DeleteDocumentsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedIds: Array<string>;
}

export interface DeleteDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UploadRawDocumentResponse extends CommandResponse {
}

export interface UploadRawDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Payload` |
     * | Type | `Edm.Binary` |
     * | Nullable | `false` |
     */
    Payload: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProjectName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProjectName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FolderName` |
     * | Type | `Edm.String` |
     */
    FolderName: string | null;
}

export interface CreateLinkDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentEntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    DocumentEntityLinkId: string | null;
}

export interface CreateLinkDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.DocumentType` |
     */
    RepositoryType: DocumentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    Icon: FileType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFile` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     * | Nullable | `false` |
     */
    LocalFile: FileType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    CategoryNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LinkedEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityType` |
     * | Type | `Edm.String` |
     */
    LinkedEntityType: string | null;
}

export interface UnlinkCategoriesResponse extends CommandResponse {
}

export interface UnlinkCategories {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    CategoryIds: Array<string>;
}

export interface DeleteDocumentCategoriesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedIds: Array<string>;
}

export interface DeleteDocumentCategories {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UpdateDocumentCategoryResponse extends CommandResponse {
}

export interface UpdateDocumentCategory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface CreateNewDocumentRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewDocumentRevisionId` |
     * | Type | `Edm.Guid` |
     */
    NewDocumentRevisionId: string | null;
}

export interface CreateNewDocumentRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetRevision: string;
}

export interface DeleteDocumentResponse extends CommandResponse {
}

export interface DeleteDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetDocumentRevisionCurrentResponse extends CommandResponse {
}

export interface SetDocumentRevisionCurrent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateDocumentCategoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryId` |
     * | Type | `Edm.Guid` |
     */
    DocumentCategoryId: string | null;
}

export interface CreateDocumentCategory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface LinkDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentEntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    DocumentEntityLinkId: string | null;
}

export interface LinkDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DocumentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentRevision` |
     * | Type | `Edm.String` |
     */
    DocumentRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LinkedEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LinkedEntityType: string;
}

export interface SetDocumentIconResponse extends CommandResponse {
}

export interface SetDocumentIcon {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewIcon` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    NewIcon: FileType | null;
}

export interface UpdateDocumentResponse extends CommandResponse {
}

export interface UpdateDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Url` |
     * | Type | `Edm.String` |
     */
    Url: string | null;
}

export interface DeleteDocumentEntityLinksResponse extends CommandResponse {
}

export interface DeleteDocumentEntityLinks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LinkedEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityType` |
     * | Type | `Edm.String` |
     */
    LinkedEntityType: string | null;
}

export interface LockDocumentResponse extends CommandResponse {
}

export interface LockDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnsetDocumentRevisionCurrentResponse extends CommandResponse {
}

export interface UnsetDocumentRevisionCurrent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetDocumentFileResponse extends CommandResponse {
}

export interface SetDocumentFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewFile` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     * | Nullable | `false` |
     */
    NewFile: FileType;
}

export interface UnlockDocumentResponse extends CommandResponse {
}

export interface UnlockDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CopyDocumentEntityLinksFromSourceEntityListToTargetEntityListResponse extends CommandResponse {
}

export interface CopyDocumentEntityLinksFromSourceEntityListToTargetEntityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityLinkToCopyParameterTypes` |
     * | Type | `Collection(Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.EntityLinkToCopyParameterType)` |
     * | Nullable | `false` |
     */
    EntityLinkToCopyParameterTypes: Array<EntityLinkToCopyParameterType>;
}

export interface CreateExternalDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
}

export interface CreateExternalDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    Icon: FileType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    CategoryNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Url` |
     * | Type | `Edm.String` |
     */
    Url: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UrlSource` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.UrlSourceEnum` |
     */
    UrlSource: UrlSourceEnum | null;
}

export interface CreateLinkExternalDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentEntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    DocumentEntityLinkId: string | null;
}

export interface CreateLinkExternalDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    Icon: FileType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    CategoryNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LinkedEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityType` |
     * | Type | `Edm.String` |
     */
    LinkedEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UrlSource` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.UrlSourceEnum` |
     */
    UrlSource: UrlSourceEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Url` |
     * | Type | `Edm.String` |
     */
    Url: string | null;
}

export interface FileType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `contents` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    contents: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `data` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    data: string;
}

export interface EntityLinkToCopyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceLinkedEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceLinkedEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceLinkedEntityType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceLinkedEntityType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetLinkedEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetLinkedEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetLinkedEntityType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetLinkedEntityType: string;
}

export interface GetDocumentFileResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    File: FileType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.FileType` |
     */
    Icon: FileType | null;
}

export interface GetDocumentFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FileId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
}

export interface GetCategoriesNotAssociatedToDocumentResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryNId` |
     * | Type | `Edm.String` |
     */
    DocumentCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryName` |
     * | Type | `Edm.String` |
     */
    DocumentCategoryName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryDescription` |
     * | Type | `Edm.String` |
     */
    DocumentCategoryDescription: string | null;
}

export interface GetCategoriesNotAssociatedToDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface GetDocumentsLinkedToEntityResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.DocumentType` |
     */
    RepositoryType: DocumentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    EntityLinkId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
}

export interface GetDocumentsLinkedToEntity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EntityId: string;
}

export interface GetDocumentsNotLinkedToEntitiesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.DocumentType` |
     */
    RepositoryType: DocumentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
}

export interface GetDocumentsNotLinkedToEntities {
}

export interface GetDocumentCategoriesDetailsAssociatedToDocumentResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryName` |
     * | Type | `Edm.String` |
     */
    DocumentCategoryName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryDescription` |
     * | Type | `Edm.String` |
     */
    DocumentCategoryDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface GetDocumentCategoriesDetailsAssociatedToDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface IQueryable {
}

export interface BaseResponse extends CommandResponse {
}

export interface GetDocumentFile2Params {
    function?: GetDocumentFile | null;
}

export interface GetCategoriesNotAssociatedToDocument2Params {
    function?: GetCategoriesNotAssociatedToDocument | null;
}

export interface GetDocumentsLinkedToEntity2Params {
    function?: GetDocumentsLinkedToEntity | null;
}

export interface GetDocumentsNotLinkedToEntities2Params {
    function?: GetDocumentsNotLinkedToEntities | null;
}

export interface GetDocumentCategoriesDetailsAssociatedToDocument2Params {
    function?: GetDocumentCategoriesDetailsAssociatedToDocument | null;
}

export interface LinkCategories2Params {
    command?: LinkCategories | null;
}

export interface DeleteDocumentCategory2Params {
    command?: DeleteDocumentCategory | null;
}

export interface UnlinkDocument2Params {
    command?: UnlinkDocument | null;
}

export interface CopyDocumentRevision2Params {
    command?: CopyDocumentRevision | null;
}

export interface CreateDocument2Params {
    command?: CreateDocument | null;
}

export interface UploadDocuments2Params {
    command?: UploadDocuments | null;
}

export interface DeleteDocuments2Params {
    command?: DeleteDocuments | null;
}

export interface UploadRawDocument2Params {
    command?: UploadRawDocument | null;
}

export interface CreateLinkDocument2Params {
    command?: CreateLinkDocument | null;
}

export interface UnlinkCategories2Params {
    command?: UnlinkCategories | null;
}

export interface DeleteDocumentCategories2Params {
    command?: DeleteDocumentCategories | null;
}

export interface UpdateDocumentCategory2Params {
    command?: UpdateDocumentCategory | null;
}

export interface CreateNewDocumentRevision2Params {
    command?: CreateNewDocumentRevision | null;
}

export interface DeleteDocument2Params {
    command?: DeleteDocument | null;
}

export interface SetDocumentRevisionCurrent2Params {
    command?: SetDocumentRevisionCurrent | null;
}

export interface CreateDocumentCategory2Params {
    command?: CreateDocumentCategory | null;
}

export interface LinkDocument2Params {
    command?: LinkDocument | null;
}

export interface SetDocumentIcon2Params {
    command?: SetDocumentIcon | null;
}

export interface UpdateDocument2Params {
    command?: UpdateDocument | null;
}

export interface DeleteDocumentEntityLinks2Params {
    command?: DeleteDocumentEntityLinks | null;
}

export interface LockDocument2Params {
    command?: LockDocument | null;
}

export interface UnsetDocumentRevisionCurrent2Params {
    command?: UnsetDocumentRevisionCurrent | null;
}

export interface SetDocumentFile2Params {
    command?: SetDocumentFile | null;
}

export interface UnlockDocument2Params {
    command?: UnlockDocument | null;
}

export interface CopyDocumentEntityLinksFromSourceEntityListToTargetEntityList2Params {
    command?: CopyDocumentEntityLinksFromSourceEntityListToTargetEntityList | null;
}

export interface CreateExternalDocument2Params {
    command?: CreateExternalDocument | null;
}

export interface CreateLinkExternalDocument2Params {
    command?: CreateLinkExternalDocument | null;
}
